import React from "react";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import EmptyState from "./EmptyState";
import styles from "./noResultsFound.module.scss";
const NoResultsFound = ({ colSpan, ...content }) => {
    return (React.createElement(TableRow, null,
        React.createElement(TableCell, { colSpan: colSpan, className: styles.root },
            React.createElement(EmptyState, { ...content }))));
};
export default NoResultsFound;
//# sourceMappingURL=NoResultsFound.js.map